import { Fetcher } from '@pp/core/src/api/Fetcher';

import { GameConfigData } from './types';

export interface FetchGameConfigParams {
  url: string;
  force: boolean;
}

export const fetchGameConfigDataData = ({ url, force }: FetchGameConfigParams): Promise<GameConfigData> => {
  return Fetcher.fetch<GameConfigData>(url, {
    params: {},
    force: force,
  });
};
